import { paymentMethod } from "data/constant/key-account-payment-methods";

export const initialFilterState = () => {
  return {
    dateType: "shift",
    startDate: null,
    endDate: null,
    searchKey: "",
    searchType: "name",
    order: "desc",
    paymentMethod: {
      isSelectedAll: true,
      value: paymentMethod.map((option) => option.value),
    },
    page: 1,
    perPage: 10,
  };
};
